import * as UI from "@iyk/ui"

import { LoaderResponse } from "@iyk/remix"
import { type MetaFunction } from "@remix-run/react"
import { Effect, Option } from "effect"
import { Remix } from "../../server/main.ts"
import { Assets } from "../../shared/assets.ts"
import { BasicLayout } from "../../shared/basic-layout.tsx"
import { COMPANY_NAME } from "../../shared/constants.ts"
import { formatCents } from "../../shared/format-cents.ts"
import { OpenGraph } from "../../shared/open-graph.ts"
import { InfluencerRoutes } from "../influencer-routes.ts"
import { Link } from "../ui/link.tsx"
import { VerifiedProfileIcon } from "../ui/verified-icon.tsx"

export const meta: MetaFunction<typeof loader> = ({ location }) => {
  const title = `Landing | ${COMPANY_NAME}`
  return [
    { title },
    ...OpenGraph.generateProperties({
      title,
      pathname: location.pathname,
      type: "website",
    }),
  ]
}

export const loader = Remix.loader.handler(({ capabilities: { influencerSessions } }) =>
  influencerSessions.authenticated.pipe(
    Effect.option,
    Effect.map((session) =>
      Option.isSome(session)
        ? LoaderResponse.TemporaryRedirect(InfluencerRoutes.home)
        : LoaderResponse.Ok(null),
    ),
  ),
)

export default function InfluencerLandingRoute() {
  return (
    <BasicLayout>
      <div className="md:w-[358px] mx-auto pt-8 md:pt-0 flex flex-col items-center justify-between md:justify-center gap-14">
        <div className="flex flex-col gap-2">
          <h1 className="text-xs-upper">Welcome to {COMPANY_NAME}</h1>
          <img src={Assets.images.logo} alt={COMPANY_NAME} className="object-contain h-11" />
        </div>
        <div className="flex flex-col items-center gap-14">
          <div className="flex flex-col text-center gap-3 px-14">
            <h2 className="text-xs-upper">Create an account to</h2>
            <h2 className="text-[28px] leading-[100%] tracking-[-0.2px]">
              Earn cash through referrals
            </h2>
          </div>
          <div className="grid gap-20 rounded bg-black px-3 py-4 w-[calc(100%-4rem)] shadow-[0px_25px_50px_-12px_rgba(0,0,0,0.25)]">
            <div className="flex items-center gap-1">
              <span className="text-sm text-gray-1">your.name</span>
              <VerifiedProfileIcon />
            </div>
            <div className="flex flex-col gap-1">
              <p className="text-xs text-gray-8">Balance</p>
              <p className="text-xl-title flex items-center gap-2 text-gray-1">
                {formatCents(520000)}
              </p>
            </div>
          </div>
        </div>
        <Link
          to={InfluencerRoutes.login}
          className={UI.classForButton({ kind: "solid", size: "lg", className: "w-full" })}
        >
          Get started
        </Link>
      </div>
    </BasicLayout>
  )
}
